import { render } from "./NotificationForm.vue?vue&type=template&id=400a6bf4&scoped=true"
import script from "./NotificationForm.vue?vue&type=script&lang=js"
export * from "./NotificationForm.vue?vue&type=script&lang=js"

import "./NotificationForm.vue?vue&type=style&index=0&id=400a6bf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-400a6bf4"]])

export default __exports__